import { useMemo } from 'react'
import { NotificationType } from 'src/services/apollo/generated/graphql'

export const rankingNotificationTypes: NotificationType[] = [
  NotificationType.DailyRanking,
  NotificationType.WeeklyRanking,
  NotificationType.MonthlyRanking,
  NotificationType.NewbiesRanking,
]

export const systemNotificationTypes: NotificationType[] = [
  // System notification with dynamic content - Admins can send any content to users in this type
  NotificationType.System,

  NotificationType.ContestReward,
  NotificationType.ModelClaim,
  NotificationType.ModelClaimedByOthers,
  NotificationType.TrainingTaskCompleted,
  NotificationType.Privilege,
  NotificationType.MembershipGifted,
  NotificationType.MembershipExpired,
  NotificationType.MembershipRenewed,
  NotificationType.MembershipRenewalFailed,
  NotificationType.PaymentFailed,

  // NSFW Moderations
  NotificationType.ModelCoverNsfw,
  NotificationType.UserAvatarNsfw,
  NotificationType.UserCoverNsfw,

  NotificationType.AppealAccepted,
  NotificationType.AppealRejected,

  ...rankingNotificationTypes,
]

export type TabType =
  | 'likes'
  | 'comments'
  | 'followers'
  | 'subscriptions'
  | 'system'
  | 'news'
interface TabEntry {
  id: string
  label: TabType
  listType: 'plain' | 'external'
  types: NotificationType[]
}

export const useNotificationTabs = () => {
  const tabValues: TabEntry[] = useMemo(
    () => [
      {
        id: 'likes',
        label: 'likes',
        listType: 'plain',
        types: [NotificationType.Like, NotificationType.ItemLike],
      },
      {
        id: 'comments',
        label: 'comments',
        listType: 'plain',
        types: [NotificationType.Comment, NotificationType.CommentReply],
      },
      {
        id: 'followers',
        label: 'followers',
        listType: 'plain',
        types: [NotificationType.Follow],
      },
      {
        id: 'system',
        label: 'system',
        listType: 'plain',
        types: systemNotificationTypes,
      },
      {
        id: 'news',
        label: 'news',
        listType: 'external',
        types: [NotificationType.News],
      },
    ],
    [],
  )

  return tabValues
}

export const useAllNotificationTypesInTabs = () => {
  const tabValues = useNotificationTabs()
  return tabValues.map(tab => tab.types).flat()
}

export const warningNotificationTypes: NotificationType[] = [
  NotificationType.PaymentFailed,
]
export const highlightedNotificationTypes: NotificationType[] = [
  NotificationType.Privilege,
  NotificationType.MembershipGifted,
  NotificationType.MembershipExpired,
  NotificationType.MembershipRenewed,
  NotificationType.MembershipRenewalFailed,
  NotificationType.System,
]

export const appealNotificationTypes: NotificationType[] = [
  NotificationType.AppealAccepted,
  NotificationType.AppealRejected,
]
